interface OtpTimerProps {
  remainingTime: number;
  isResending: boolean;
  onResend: () => void;
}

export const OtpTimer = ({
  remainingTime,
  isResending,
  onResend,
}: OtpTimerProps) => {
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");

    const remainingSeconds = (seconds % 60).toString().padStart(2, "0");

    return `${minutes}:${remainingSeconds}`;
  };

  return (
    <div className="flex justify-center">
      {remainingTime > 0 ? (
        <p className="font-kalameh text-body-2 text-white">
          ارسال مجدد کد تا{" "}
          <span dir="ltr" className="font-kalameh text-body-2">
            {formatTime(remainingTime)}
          </span>
        </p>
      ) : (
        <button
          type="button"
          onClick={onResend}
          disabled={isResending}
          className="font-kalameh text-button-3 bg-white w-32.75 h-10 rounded-4xl transition hover:text-[#5abcf0] disabled:cursor-not-allowed disabled:opacity-50"
        >
          {isResending ? "در حال ارسال..." : "ارسال مجدد کد"}
        </button>
      )}
    </div>
  );
};
